setLiveAccessSessionDetails